import { useGame } from "@/contexts/GameContext";
import { Star, Check } from "lucide-react";
import { difficulties } from "@/lib/constants";
import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";

export default function DifficultyStep() {
  const { state, dispatch } = useGame();
  const currentDifficulties = state.settings?.difficulty || [];

  const toggleDifficulty = (level) => {
    const newDifficulties = currentDifficulties.includes(level)
      ? currentDifficulties.filter((d) => d !== level)
      : [...currentDifficulties, level].sort();

    dispatch({
      type: "UPDATE_SETTINGS",
      payload: { difficulty: newDifficulties },
    });
  };

  return (
    <div className="space-y-4">
      <div className="grid gap-4">
        {difficulties.map((difficulty) => {
          const isSelected = currentDifficulties.includes(difficulty.level);

          return (
            <Button
              key={difficulty.level}
              onClick={() => toggleDifficulty(difficulty.level)}
              size="lg"
              variant="outline"
              className={cn(
                "whitespace-normal relative bg-card/60 backdrop-blur-sm h-auto p-6 rounded-xl outline transition-all duration-200 flex flex-col items-center justify-between gap-2",
                isSelected ? "outline-primary/50" : "outline-none"
              )}
            >
              {/* Gwiazdki - mniejsze */}
              <div className={`flex ${difficulty.color}`}>
                {Array.from({ length: difficulty.level }).map((_, i) => (
                  <Star key={i} className="size-4 fill-current" />
                ))}
                {Array.from({ length: 3 - difficulty.level }).map((_, i) => (
                  <Star
                    key={`empty-${i}`}
                    className="size-4 text-foreground/10"
                  />
                ))}
              </div>
              <div className="font-bold text-lg">{difficulty.name}</div>
              <div className="text-sm">{difficulty.description}</div>

              {/* Wskaźnik zaznaczenia */}
              {isSelected && (
                <motion.div
                  initial={{ scale: 0.5, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  className="absolute z-10 top-2 right-2 w-5 h-5 bg-primary rounded-full flex items-center justify-center"
                >
                  <Check className="w-3 h-3 text-white" />
                </motion.div>
              )}
            </Button>
          );
        })}
      </div>

      {currentDifficulties.length === 0 && (
        <div className="text-center mt-4">
          <p className="text-sm text-yellow-600 dark:text-yellow-400">
            Wybierz przynajmniej jeden poziom trudności
          </p>
        </div>
      )}
    </div>
  );
}
